

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="LinkBox" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { LinkBoxProps } from './LinkBox.ts';
import LinkBox from './LinkBox.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-link-box';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<LinkBoxProps>();
const changableProps = useChangableProps(componentName, props);

</script>
